import React from 'react';
import Icon from '../../../components/AppIcon';

const ContractorPerformance = () => {
  const contractors = [
    {
      id: 'C001',
      name: 'ABC Plumbing Services',
      trade: 'Plumbing',
      jobsCompleted: 45,
      avgResponseTime: '2.3 hours',
      rating: 4.8,
      totalCost: 12500,
    },
    {
      id: 'C002',
      name: 'XYZ Electrical Ltd',
      trade: 'Electrical',
      jobsCompleted: 38,
      avgResponseTime: '3.1 hours',
      rating: 4.6,
      totalCost: 9800,
    },
    {
      id: 'C003',
      name: 'QuickFix Repairs',
      trade: 'General',
      jobsCompleted: 52,
      avgResponseTime: '1.8 hours',
      rating: 4.9,
      totalCost: 8200,
    },
    {
      id: 'C004',
      name: 'Elite Appliance Repair',
      trade: 'Appliances',
      jobsCompleted: 28,
      avgResponseTime: '4.2 hours',
      rating: 4.5,
      totalCost: 6400,
    },
  ];

  const getRatingColor = (rating) => {
    if (rating >= 4.7) return 'var(--color-success)';
    if (rating >= 4.0) return 'var(--color-warning)';
    return 'var(--color-error)';
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground font-heading">Top Contractor Performance</h3>
        <button className="text-sm text-accent hover:underline font-caption">
          View All
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground font-caption">Contractor</th>
              <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground font-caption">Trade</th>
              <th className="text-center py-3 px-4 text-sm font-medium text-muted-foreground font-caption">Jobs</th>
              <th className="text-center py-3 px-4 text-sm font-medium text-muted-foreground font-caption">Avg Response</th>
              <th className="text-center py-3 px-4 text-sm font-medium text-muted-foreground font-caption">Rating</th>
              <th className="text-right py-3 px-4 text-sm font-medium text-muted-foreground font-caption">Total Cost</th>
            </tr>
          </thead>
          <tbody>
            {contractors?.map((contractor) => (
              <tr key={contractor?.id} className="table-row">
                <td className="py-3 px-4">
                  <div>
                    <p className="text-sm font-medium text-foreground">{contractor?.name}</p>
                    <p className="text-xs text-muted-foreground font-data">{contractor?.id}</p>
                  </div>
                </td>
                <td className="py-3 px-4">
                  <span className="text-sm text-foreground font-caption">{contractor?.trade}</span>
                </td>
                <td className="py-3 px-4 text-center">
                  <span className="text-sm font-medium text-foreground font-data">{contractor?.jobsCompleted}</span>
                </td>
                <td className="py-3 px-4 text-center">
                  <span className="text-sm text-foreground font-data">{contractor?.avgResponseTime}</span>
                </td>
                <td className="py-3 px-4 text-center">
                  <div className="flex items-center justify-center gap-1">
                    <Icon name="Star" size={14} color={getRatingColor(contractor?.rating)} />
                    <span className="text-sm font-medium font-data" style={{ color: getRatingColor(contractor?.rating) }}>
                      {contractor?.rating}
                    </span>
                  </div>
                </td>
                <td className="py-3 px-4 text-right">
                  <span className="text-sm font-medium text-foreground font-data">
                    £{contractor?.totalCost?.toLocaleString()}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ContractorPerformance;